import { PartialDeep } from 'type-fest';

import { IAddon } from 'src/graphql/schema';
import formatPrice from 'src/utils/currency-code-to-symbol';
import { Card } from '@/components/ui/card';
import { cn } from 'src/lib/utils';
import { Badge } from '@/components/ui/badge';

type Props = {
  addon: PartialDeep<IAddon>;
  className?: string;
};

export default function BillingAddon({ addon, className }: Props) {
  return (
    <Card className={cn('p-6 space-y-6', className)}>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h6 className="text-sm sm:text-lg text-foreground font-semibold">
          {addon.externalName} <span>({addon.quantity} units)</span>
        </h6>
        <Badge className="bg-ck-gray-100 text-foreground whitespace-nowrap">Add-on</Badge>
      </div>
      <div className="flex">
        <div className="flex flex-col gap-2 flex-1">
          <div className="text-sm text-muted-foreground">
            Price/
            <span className="capitalize">{addon.periodUnit}</span>
          </div>
          <strong className="text-base font-semibold leading-4">{formatPrice(addon.currencyCode, addon.price)}</strong>
        </div>
      </div>
    </Card>
  );
}
